import { ViewFilterChild, IViewFiltersData } from '@api'
import ChildFilters from './ChildFilters'
import ParentFilter from './ParentFilter'
import { SAFEDISTANCING } from './viewFiltersCalculations'
import { ItemsKeysArray } from 'components/AdminFloorPlan/hooks/useMapViewSettings'

type staticFilterProps = {
  isFiltered: boolean
  filters: ViewFilterChild[]
  viewFiltersData: IViewFiltersData
  mapViewSetting: {
    mapViewSettings: any
    updateMapViewSettings: (key: string, value: string, itemsKeys: ItemsKeysArray) => void
  }
}
const StaticFilters = ({
  filters,
  isFiltered,
  viewFiltersData,
  mapViewSetting,
}: staticFilterProps) => {
  return (
    <div>
      {filters?.map(({ filterId, children }: ViewFilterChild, filtersIndex: number) => (
        <div key={filterId + filtersIndex}>
          {children.length ? (
            <ParentFilter
              isFiltered={isFiltered}
              id={filterId}
              viewFiltersData={viewFiltersData}
              disabled={filterId === SAFEDISTANCING}>
              {children.map((id: string, childFilterIndex: number) => (
                <ChildFilters
                  key={id + childFilterIndex}
                  id={id}
                  viewFiltersData={viewFiltersData}
                  mapViewSetting={mapViewSetting}
                />
              ))}
            </ParentFilter>
          ) : null}
        </div>
      ))}
    </div>
  )
}

export default StaticFilters
